import React, { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { chat } from "../services/userService";
import Loading from "../components/Loading";

const Chat = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [questionCount, setQuestionCount] = useState(0); // Add state to track the number of questions asked
  const [chatLimitReached, setChatLimitReached] = useState(false); // Add state to track if chat limit is reached

  const auth = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const userID = auth?.auth?.donor_id;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (questionCount >= 4) {
      setChatLimitReached(true);
      return;
    }
    setLoading(true);
    try {
      const response = await chat(
        axiosPrivate,
        question,
        userID,
        auth?.auth?.token
      );
      console.log("Response:", response);
      setAnswer(response.answer);
      setQuestionCount(questionCount + 1); // Increment the question count
    } catch (error) {
      console.error("Error fetching answer:", error);
      setAnswer("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sm:p-6 font-pop flex flex-col h-screen bg-white">
      <h1 className="text-2xl font-bold mb-4 ml-4">Blood Donation Q&A</h1>
      <form
        onSubmit={handleSubmit}
        className="border-t-2 border-gray-200 px-4 pt-4 mb-10 sm:mb-0"
      >
        <div className="relative flex items-center mb-10">
          <input
            id="question"
            type="text"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Question about blood donations..."
            className="input-red rounded-full"
            disabled={chatLimitReached} // Disable input if chat limit is reached
          />
          <div className="absolute right-3 top-2 items-center inset-y-0 ">
            <button
              type="submit"
              className="inline-flex items-center justify-center rounded-full h-8 w-8 transition duration-200 ease-in-out text-white bg-red-500 hover:bg-red-600 focus:outline-none"
              disabled={chatLimitReached} // Disable button if chat limit is reached
            >
              <ArrowForwardIcon />
            </button>
          </div>
        </div>
      </form>
      {loading ? (
        <div className="flex justify-center items-center">
          <div className="loader">
            <Loading />
          </div>
        </div>
      ) : (
        answer && (
          <div>
            <p className="mt-2 text-white bg-red-600 p-10 rounded-lg shadow-md mb-10">
              {answer}
            </p>
          </div>
        )
      )}
      {chatLimitReached && (
        <div className="text-center text-red-500 font-bold mt-4">
          Chats exhausted. You can only ask 5 questions.
        </div>
      )}
    </div>
  );
};

export default Chat;
